<template>
    <p class="social-connector text-center auth-or-divider" :class="marginClass">
        <span>{{ $t("auth.or") }}</span>
    </p>
</template>

<script>
    export default {
        name: "AuthOrDivider",
        props: {
            tight: {
                type: Boolean,
                default: false,
            },
        },
        computed: {
            marginClass() {
                return this.tight
                    ? "mb-15 mt-15"
                    : "mb-sm-25 mb-15 mt-sm-30 mt-20";
            },
        },
    };
</script>

<style scoped>
    .auth-or-divider span {
        display: inline-block;
        padding: 0 12px;
        color: #868eae;
        font-size: 13px;
        letter-spacing: 0.02em;
    }
</style>
